import React from "react";
import p1 from "../Assets/p1.jpeg";
import p2 from "../Assets/p2.jpeg";
import p3 from "../Assets/p3.jpeg";
import p4 from "../Assets/p4.jpeg";
import p5 from "../Assets/p5.jpeg";
import p6 from "../Assets/p6.png";


function Projects() {
  return (
    <div className="pmain">
      <div className="container">
        <center>
          <h1>
            MY RECENT <strong>PROJECTS</strong>
          </h1>
          <p>Here are my few projects, I've worked on recently</p>
        </center>

        <div className="Row">
          <div className="p1">
            <img src={p1} alt="P1" />
            <center>
              <h2>GROCERY SHOP APP</h2>
              <p>
                A Grocery App for local stores to manage online orders. This
                Project was made for the client as per his requirements using
                Kotlin And Firebase.
              </p>
              <a target={"blank"} href="https://github.com/wajeeez/Grocery-App">
                Link
              </a>
            </center>
          </div>

          <div className="p1">
            <img src={p2} alt="P1" />
            <center>
              <h2>DARK ROOM APP </h2>
              <p>
                Dark Room is an android chat application that can be used as a
                service provider for a small communities like college groups and
                among small teams of developers.
              </p>
              <a target={"blank"} href="https://github.com/wajeeez/Dark_Room">
                Link
              </a>
            </center>
          </div>

          <div className="p1">
            <img src={p3} alt="P1" />
            <center>
              <h2>SCREEN TEST APP</h2>
              <p>
                A screen test Android app is an application that helps you to
                test various aspects of your screen, such as color accuracy,
                contrast, dead pixels, and viewing angles.{" "}
              </p>
              <a target={"blank"} href="https://github.com/wajeeez/">
                Link
              </a>
            </center>
          </div>

          <div className="p1">
            <img src={p4} alt="P1" />
            <center>
              <h2>BUZZ FEED APP</h2>
              <p>
                Buzz Feed is an android news app that fetches news from an api
                and show it in a custom recycler view, News articles can be
                clicked and readed fully on the browser.
              </p>
              <a
                target={"blank"}
                href="https://github.com/wajeeez/BUZZ_FEED_ANDROID"
              >
                Link
              </a>
            </center>
          </div>

          <div className="p1">
            <img src={p5} alt="P1" />
            <center>
              <h2>RESIDE & DINE APP</h2>
              <p>
                Reside and Dine is a mobile application designed to make it
                easier for users to discover and book dining experiences at
                high-end residential properties.
              </p>
              <a
                target={"blank"}
                href="https://github.com/wajeeez/RoomRentalApp"
              >
                Link
              </a>
            </center>
          </div>

          <div className="p1">
            <img src={p6} alt="P1" />
            <center>
              <h2>FUZZ FEED APP</h2>
              <p>
              Buzz Feed is a mobile news app made using Flutter that fetches news from an api and show it in a custom recycler view, News articles can be clicked.
              </p>
              <a
                target={"blank"}
                href="https://github.com/wajeeez/"
              >
                Link
              </a>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
